var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "basic-icon",
    d: "M38.5,40h-29C6.468,40,4,37.532,4,34.5v-21C4,10.468,6.468,8,9.5,8h29c3.032,0,5.5,2.468,5.5,5.5v21 C44,37.532,41.532,40,38.5,40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBasic);
export default __webpack_public_path__ + "static/media/banner-basic.8eb7ab09bcc96e56324677df5a9d3500.svg";
export { ForwardRef as ReactComponent };